import { z } from 'zod';
import { fieldRegistry } from './registry';
import type { FormFieldSchema } from './types';

/**
 * Generates a Zod schema from an array of custom field definitions.
 * It ignores presentational fields that don't collect data.
 */
export function generateZodSchema(fields: FormFieldSchema[]): z.ZodObject<z.ZodRawShape> {
  const shape: Record<string, z.ZodTypeAny> = {};

  fields.forEach((field) => {
    const fieldDef = fieldRegistry.get(field.type);

    // Skip if field type is not registered
    if (!fieldDef) {
      console.warn(`Field type "${field.type}" not found in registry.`);
      return;
    }

    // Skip presentational fields (they don't have data keys)
    if (fieldDef.isPresentational || field.isPresentational) {
      return;
    }

    // Use the name (data key) as the object key
    // In our system, 'id' and 'name' are often used interchangeably for form keys
    const key = field.name || field.id;
    if (!key) {
      console.warn(`Field of type "${field.type}" is missing both 'id' and 'name'. Skipping.`);
      return;
    }

    shape[key] = fieldDef.buildValidation(field);
  });

  return z.object(shape);
}
